import { useState } from 'react';

import { clockIcon, menuIcon, closeIcon } from './utils/icons';

const SteppedContent = ({ attributes, useStep, children }) => {
	const { data, title, isDoneBtn, doneBtnLink } = attributes;
	const { step, onSetStep, minuteText, secondText } = useStep;

	const [mobileMenuActive, setMobileMenuActive] = useState('');

	const remainingText = minuteText ? `${minuteText} and ${secondText}` : secondText;

	return <div className='stpContent'>
		<nav className='stpNav'>
			{mobileMenuActive ? <a className='menuClose' title='Close Menu' onClick={e => {
				e.preventDefault();
				setMobileMenuActive('');
			}}>{closeIcon}</a> : <a className='menuOpen' title='Open Menu' onClick={e => {
				e.preventDefault();
				setMobileMenuActive('active');
			}}>{menuIcon}</a>}

			<h2>{title}</h2>

			<div className='remainingTime'>
				{clockIcon}
				{remainingText}
			</div>
		</nav>

		<div className='stpSection' onClick={() => setMobileMenuActive('')}>
			<nav className={`stpMenu ${mobileMenuActive}`}>
				<ol>
					{data.length ? data.map((d) => <li key={d.step} data-completed={d.step <= step} data-selected={d.step === step} onClick={() => onSetStep(d.step)}>
						<a>
							<span>{d.title}</span>
						</a>
					</li>) : <li><a>Please add a step!</a></li>}
				</ol>
			</nav>

			<div className='stpStepsWrapper'>
				{children}

				<div className='sptStepsControls'>
					<div className='controlsInner'>
						{1 < step && <button className='docControlBtn prevBtn' title='Previous step' onClick={() => onSetStep(step - 1)}>Back</button>}

						{step === data.length && isDoneBtn && <a href={doneBtnLink} className='docControlBtn doneBtn' title='Document Complete'>Done</a>}

						{step < data.length && <button className='docControlBtn nextBtn' title='Next step' onClick={() => onSetStep(step + 1)}>Next</button>}
					</div>
				</div>
			</div> {/* Steps Wrapper */}
		</div>
	</div>
}
export default SteppedContent;